import React, { useRef } from 'react';
import JoditEditor from 'jodit-react';

const config = {
  buttons: [
    'bold',
    'italic',
    'link',
    'unlink',
    'underline',
    'strikethrough',
    'ul',
    'ol',
    'outdent',
    'indent',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    'image',
    'video',
    'table',
    'align',
    'undo',
    'redo',
    'hr',
    'eraser',
    'copyformat',
    'selectall',
    'cut',
    'copy',
    'paste',
    'color',
  ],
  height: '300',
  toolbarAdaptive: false,
};

const RichTextEditor = ({ initialValue, getValue }) => {
  const editor = useRef(null);

  return (
    <JoditEditor
      ref={editor}
      value={initialValue}
      style={{ maxHeight: '300px' }}
      config={config}
      tabIndex={1}
      //   onBlur={(newContent) => getValue(newContent)}
      onChange={(newContent) => getValue(newContent)}
    />
  );
};

export default RichTextEditor;
